<template>
    <ProcColumnPanel
        title="Anexos"
        :subtitle="`${resumo.qtd_anexo_pendente || 0} pendente(s)`"
        :expanded="expanded"
        @toggle-expand="$emit('toggle-expand')"
    >
        <div v-if="anexos.length === 0" class="empty-box">
            Nenhum anexo configurado para esta etapa.
        </div>

        <div
            v-for="anexo in anexos"
            :key="`${anexo.idtpdoc}-${anexo.idanexo || 'novo'}`"
            class="proc-card"
        >
            <div class="card-main">
                <div class="card-text">
                    <h4>{{ anexo.nmitem }}</h4>
                    <p v-if="anexo.instrucoes">{{ anexo.instrucoes }}</p>
                </div>

                <span :class="['status-pill', statusAnexoClasse(anexo)]">
                    {{ statusAnexoTexto(anexo) }}
                </span>
            </div>

            <div class="tag-row">
                <span v-if="anexo.ckobrigatorio === 'S'" class="tag obrigatorio">Obrigatório</span>
                <span v-if="anexo.ckobrigatorio !== 'S'" class="tag">Acessório</span>
                <span v-if="anexo.ckexige_analise === 'S'" class="tag">Análise</span>
                <span v-if="anexo.ckpermite_multiplos === 'S'" class="tag">Múltiplos</span>
            </div>

            <div v-if="anexo.idanexo" class="anexo-info row">
                <div>
                    <strong>Enviado:</strong>
                    {{ formatarDataHora(anexo.dhpostagem) }}
                </div>

                <div>
                    <strong>Referência:</strong>
                    {{ anexo.nmreferencia }}
                </div>

                <div>
                    <strong>Tamanho:</strong>
                    {{ formatarTamanho(anexo.fsize) }}
                    &nbsp;&nbsp;&nbsp;
                    <strong>Hash:</strong>
                    {{ hashResumido(anexo.fhash) }}
                </div>
            </div>

            <div class="card-actions">
                <button
                v-if="!anexo.idanexo || anexo.ckpermite_multiplos==='S'"
                    class="btn-small proc-btn"
                    type="button"
                    @click="$emit('abrir-upload', anexo)"
                >
                    Adicionar
                </button>

                <button
                    v-if="anexo.idanexo"
                    class="btn-small proc-btn"
                    type="button"
                    @click="$emit('visualizar-anexo', anexo.idanexo)"
                >
                    Visualizar
                </button>

                <button
                    v-if="anexo.idanexo"
                    class="btn-small proc-btn danger"
                    type="button"
                    @click="$emit('remover', anexo.idproc_item)"
                >
                    Remover
                </button>
            </div>
        </div>
    </ProcColumnPanel>
</template>

<script setup>
import ProcColumnPanel from './ProcColumnPanel.vue';

defineProps({
    anexos: { type: Array, default: () => [] },
    resumo: { type: Object, required: true },
    podeAnexar: { type: Boolean, default: false },
    expanded: { type: Boolean, default: false },
    statusAnexoTexto: { type: Function, required: true },
    statusAnexoClasse: { type: Function, required: true },
    podeAdicionarAnexo: { type: Function, required: true },
    formatarDataHora: { type: Function, required: true },
    formatarTamanho: { type: Function, required: true },
    hashResumido: { type: Function, required: true },
});

defineEmits(['abrir-upload', 'visualizar-anexo', 'remover', 'toggle-expand']);
</script>
